import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {SearchBO} from "./SearchBO";
import {
    WB_SearchProfileCRRow, WB_SearchProfileFCRRow, WB_SearchProfileGCRRow, WB_SearchProfileRow
} from "../PA.Core/PAdbSchemaRows";

export class SearchBOValidation {

    static Validate(aBO: SearchBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            SearchBOValidation.ValidateHeaderFields(aBO)
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return SearchBOValidation.ValidateProfiles(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return SearchBOValidation.ValidateProfileCRs(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return SearchBOValidation.ValidateProfileFCRs(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return SearchBOValidation.ValidateProfileGCRs(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static async ValidateHeaderFields(aBO: SearchBO): Promise<void> {

        const self = this;
        let searchConfigName = aBO.WB_Search.cif.SEARCH_NAME

        if(searchConfigName == '') {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingName',
                    type: MessageType.Error,
                    title: "Name cannot be empty",
                    description:"Name cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingName')
        }

        let searchType = aBO.WB_Search.cif.SEARCH_TYPE

        if(searchType == '') {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingType',
                    type: MessageType.Error,
                    title: "Type cannot be empty",
                    description:"Type cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingType')
        }
    }


    static async ValidateProfiles(aBO: SearchBO): Promise<void> {

        const self = this;
        let activeProfileRows = _.filter(aBO.WB_Search.WB_SearchProfileRows, aRow => aRow.isActive)
        let missingFieldRows = _.filter(activeProfileRows, (aRow: WB_SearchProfileRow) =>
            aRow.cif.PROFILE_NAME == '' ||
            aRow.cif.SORT_ORDER < 0 ||
            aRow.cif.DATASOURCE_TYPE == '')
        let invalidProfileNames = _.map(missingFieldRows, aRow => aRow.cif.PROFILE_ID)

        let defaultProfile = _.filter(activeProfileRows, (aRow: WB_SearchProfileRow) => aRow.cif.DEFAULT_IND == '1')

        if(missingFieldRows.length > 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingFields',
                    type: MessageType.Error,
                    title: "All values in the Profile(s) Grid must be specified before saving.",
                    description:"All values in the Profile(s) Grid must be specified before saving.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingFields')
        }

        if(defaultProfile.length == 0 && activeProfileRows.length != 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingDefaultProfile',
                    type: MessageType.Error,
                    title: "Missing Default profile.",
                    description:"Please specify one of the profiles as the default profile",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingDefaultProfile')
        }

        let arrSortOrder = _.map(activeProfileRows, aRow => _.toNumber(aRow.cif.SORT_ORDER))
        if(_.uniq(arrSortOrder).length != arrSortOrder.length) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'SortOrderProfileDuplicate',
                    type: MessageType.Error,
                    title: "Sort Order should be unique for all profiles ",
                    description:"Sort Order should be unique for all profiles.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('SortOrderProfileDuplicate')
        }
    }

    static async ValidateProfileCRs(aBO: SearchBO): Promise<void> {

        const self = this;
        let activeProfileRows = _.filter(aBO.WB_Search.WB_SearchProfileRows, aRow => aRow.isActive)

        _.forEach(activeProfileRows, (aProfileRow: WB_SearchProfileRow) => {
            let missingCRFileds = _.filter(aProfileRow.WB_SearchProfileCRRows, (aCRRow: WB_SearchProfileCRRow) => aCRRow.isActive
                && (aCRRow.cif.COLUMN_NAME == '' || aCRRow.cif.COLUMN_METATYPE == '' || aCRRow.cif.ALIGNMENT == '' || aCRRow.cif.DISPLAYTYPE == ''))
            if(missingCRFileds.length > 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'MissingCRFields'+aProfileRow.cif.WB_SEARCH_PROFILE_ID,
                        type: MessageType.Error,
                        title: "Required fields missing for profile "+ aProfileRow.cif.PROFILE_NAME,
                        description:"Column label, Meta Type, PA Type and Alignment are required fields for a query column.",
                        count: 0
                    })
            }
            else {
                aBO.ValidateMessageProvider.removeMessage('MissingCRFields'+aProfileRow.cif.WB_SEARCH_PROFILE_ID)
            }
        })
    }

    static async ValidateProfileFCRs(aBO: SearchBO): Promise<void> {

        const self = this;
        let activeProfileRows = _.filter(aBO.WB_Search.WB_SearchProfileRows, aRow => aRow.isActive)

        _.forEach(activeProfileRows, (aProfileRow: WB_SearchProfileRow) => {
            let missingCRFileds = _.filter(aProfileRow.WB_SearchProfileFCRRows, (aFCRRow: WB_SearchProfileFCRRow) => aFCRRow.isActive
                && (aFCRRow.cif.COLUMN_ID == '' || aFCRRow.cif.SORT_ORDER < 0))
            if(missingCRFileds.length > 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'MissingFCRFields'+aProfileRow.cif.WB_SEARCH_PROFILE_ID,
                        type: MessageType.Error,
                        title: "Required Filter Column fields missing for profile "+ aProfileRow.cif.PROFILE_NAME,
                        description:"Column label, Order, Field Name are required fields for a filter column.",
                        count: 0
                    })
            }
            else {
                aBO.ValidateMessageProvider.removeMessage('MissingFCRFields'+aProfileRow.cif.WB_SEARCH_PROFILE_ID)
            }

            let arrSortOrder = _.map(_.filter(aProfileRow.WB_SearchProfileFCRRows, aFCRow => aFCRow.isActive), aRow => _.toNumber(aRow.cif.SORT_ORDER))
            if(_.uniq(arrSortOrder).length != arrSortOrder.length) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'SortOrderFilterDuplicate'+aProfileRow.cif.WB_SEARCH_PROFILE_ID,
                        type: MessageType.Error,
                        title: "Sort Order should be unique for all filter columns ",
                        description:"Sort Order should be unique for all filter columns.",
                        count: 0
                    })
            }
            else {
                aBO.ValidateMessageProvider.removeMessage('SortOrderFilterDuplicate'+aProfileRow.cif.WB_SEARCH_PROFILE_ID)
            }
        })
    }

    static async ValidateProfileGCRs(aBO: SearchBO): Promise<void> {

        const self = this;
        let activeProfileRows = _.filter(aBO.WB_Search.WB_SearchProfileRows, aRow => aRow.isActive)

        _.forEach(activeProfileRows, (aProfileRow: WB_SearchProfileRow) => {
            let missingCRFileds = _.filter(aProfileRow.WB_SearchProfileGCRRows, (aGCRRow: WB_SearchProfileGCRRow) => aGCRRow.isActive
                && (aGCRRow.cif.COLUMN_ID == '' || aGCRRow.cif.SORT_ORDER < 0 || aGCRRow.cif.COLUMN_NAME == ''))
            if(missingCRFileds.length > 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'MissingGCRFields'+aProfileRow.cif.WB_SEARCH_PROFILE_ID,
                        type: MessageType.Error,
                        title: "Required Grid Column fields missing for profile "+ aProfileRow.cif.PROFILE_NAME,
                        description:"Column label, Order, Field Name are required fields for a grid column.",
                        count: 0
                    })
            }
            else {
                aBO.ValidateMessageProvider.removeMessage('MissingGCRFields'+aProfileRow.cif.WB_SEARCH_PROFILE_ID)
            }

            let arrSortOrder = _.map(_.filter(aProfileRow.WB_SearchProfileGCRRows, aGCRow => aGCRow.isActive), aRow => _.toNumber(aRow.cif.SORT_ORDER))
            if(_.uniq(arrSortOrder).length != arrSortOrder.length) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'SortOrderDuplicate'+aProfileRow.cif.WB_SEARCH_PROFILE_ID,
                        type: MessageType.Error,
                        title: "Sort Order should be unique for all grid columns ",
                        description:"Sort Order should be unique for all grid columns.",
                        count: 0
                    })
            }
            else {
                aBO.ValidateMessageProvider.removeMessage('SortOrderDuplicate'+aProfileRow.cif.WB_SEARCH_PROFILE_ID)
            }
        })
    }

    private static addMessage(aBO: SearchBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}